/*
  Barrier - cart gifts (managed only on lines this script added).
  1) Gift sachet (since 29.10.2026): when the coupon "סאשט מתנה בקניה מעל 200 ש"ח" is on the cart
     and the rest of the cart is 200+, one sachet in the OPPOSITE flavor is added.
  2) Creatine Barrier (since 01.11.2026): every Power Barrier line (one-time or subscription)
     gets Creatine Barrier matching its size: one 30-sachet box per 30 Power units
     (Power 30 = 1 box, 60 = 2, 90 = 3, times the line quantity), shown as a gift at ₪0.
     Only the 30 variant has stock, so the gift always uses it.
     The price is zeroed by an automatic 100% discount on Creatine Barrier.
*/
(function () {
  if (window.__barrierGiftSachet) return;
  window.__barrierGiftSachet = true;

  // ---- 1) sachet ----
  var GIFT_CODE = 'סאשט מתנה בקניה מעל 200 ש"ח';
  var GIFT_GRAPE = 67788141592812; // gift-only product (grape)
  var GIFT_KIWI = 67748172759276; // single sachet kiwi strawberry (also used by other flows)
  var GIFT_PROP = '_gift'; // marks the sachet line THIS script added
  var GIFT_LABELS = {};
  GIFT_LABELS[GIFT_GRAPE] = 'סאשט ענבים במתנה מאיתנו · 100% הנחה ברכישה מעל ₪200';
  GIFT_LABELS[GIFT_KIWI] = 'סאשט תות קיווי במתנה מאיתנו · 100% הנחה ברכישה מעל ₪200';
  var MIN_TOTAL = 20000; // agorot

  // ---- 2) creatine ----
  var CREATINE_PROP = '_gift_creatine';
  var CREATINE_30 = 47689975169260; // Creatine Barrier - 30 sachets
  var CREATINE_LABEL = 'מתנה מאיתנו לכל רוכש Barrier';

  function isSachetGift(i) {
    if (!i) return false;
    if (i.variant_id === GIFT_GRAPE) return true;
    return !!(i.properties && i.properties[GIFT_PROP]);
  }
  function isCreatineGift(i) {
    return !!(i && i.properties && i.properties[CREATINE_PROP]);
  }
  function isAnyGift(i) {
    return isSachetGift(i) || isCreatineGift(i);
  }
  function isPower(i) {
    return String(i.product_title || '').indexOf('Power Barrier') !== -1 && i.quantity > 0;
  }

  var lastCart = null;
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var pending = false;
  var timer = null;

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/["'״׳`]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  var TARGET_CODE = norm(GIFT_CODE);
  function hasGiftCode(cart) {
    return (cart.discount_codes || []).some(function (d) {
      return norm(d && d.code) === TARGET_CODE;
    });
  }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function renderSections(sections, itemCount) {
    if (!sections) return;
    var drawerEl = document.querySelector('cart-drawer');
    if (sections['cart-drawer']) {
      var target = document.getElementById('CartDrawer');
      var fresh = parse(sections['cart-drawer'], '#CartDrawer');
      if (target && fresh) {
        target.innerHTML = fresh.innerHTML;
        var overlay = target.querySelector('#CartDrawer-Overlay');
        if (overlay && drawerEl && drawerEl.close) {
          overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
        }
      }
    }
    if (drawerEl && typeof itemCount === 'number') {
      drawerEl.classList.toggle('is-empty', itemCount === 0);
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var freshBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }
  }

  function post(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // Desired gift lines: { variantId: { qty, prop } }
  function desiredGifts(cart) {
    var want = {};
    var paid = (cart.items || []).filter(function (i) {
      return !isAnyGift(i);
    });
    var powers = paid.filter(isPower);

    // sachet
    var othersTotal = paid.reduce(function (sum, i) {
      return sum + (i.final_line_price || 0);
    }, 0);
    if (hasGiftCode(cart) && othersTotal >= MIN_TOTAL) {
      var hasGrape = false;
      var hasKiwi = false;
      paid.forEach(function (i) {
        if (!i.final_line_price) return;
        var v = String(i.variant_title || '');
        if (v.indexOf('ענבים') !== -1) hasGrape = true;
        if (v.indexOf('קיווי') !== -1) hasKiwi = true;
      });
      var sachet = hasGrape && !hasKiwi ? GIFT_KIWI : GIFT_GRAPE;
      want[sachet] = { qty: 1, prop: GIFT_PROP };
    }

    // creatine: one 30-box per 30 Power units
    var boxes = 0;
    powers.forEach(function (i) {
      var m = String(i.variant_title || '').match(/(\d+)\s*יחידות/);
      var units = m ? Number(m[1]) : 30;
      boxes += Math.max(1, Math.round(units / 30)) * i.quantity;
    });
    if (boxes > 0) want[CREATINE_30] = { qty: boxes, prop: CREATINE_PROP };
    return want;
  }

  var inflight = null;
  function sync() {
    if (busy) {
      pending = true;
      return inflight;
    }
    busy = true;
    inflight = getCart()
      .then(function (cart) {
        lastCart = cart;
        expect.creatine = false;
        expect.kiwi = false;
        var want = desiredGifts(cart);
        var gifts = (cart.items || []).filter(isAnyGift);
        var steps = [];
        var seen = {};
        gifts.forEach(function (g) {
          var w = want[g.variant_id];
          var sameKind = w && ((w.prop === CREATINE_PROP) === isCreatineGift(g));
          if (!sameKind || seen[g.variant_id]) {
            steps.push(['/cart/change.js', { id: g.key, quantity: 0 }]);
            return;
          }
          seen[g.variant_id] = true;
          if (g.quantity !== w.qty) steps.push(['/cart/change.js', { id: g.key, quantity: w.qty }]);
        });
        Object.keys(want).forEach(function (id) {
          if (seen[id]) return;
          var props = {};
          props[want[id].prop] = '1';
          steps.push(['/cart/add.js', { items: [{ id: Number(id), quantity: want[id].qty, properties: props }] }]);
        });
        if (!steps.length) {
          decorate();
          return;
        }
        var chain = Promise.resolve();
        var last = null;
        steps.forEach(function (s) {
          chain = chain
            .then(function () {
              return post(s[0], s[1]);
            })
            .then(function (res) {
              if (res && res.sections) last = res;
            });
        });
        return chain.then(getCart).then(function (fresh) {
          lastCart = fresh;
          renderSections(last && last.sections, fresh.item_count);
          decorate();
        });
      })
      .catch(function (e) {
        console.warn('[barrier-gifts]', e);
      })
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          return sync();
        }
      });
    return inflight;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  function isCartUrl(url) {
    return /\/cart(\/|\.js|$|\?)|\/discount\//.test(String(url || ''));
  }

  // ---- fast path: add the gifts BEFORE the theme's own add-to-cart request,
  // so the drawer opens once, already showing Power + gifts. ----
  var variantInfo = {}; // variantId -> { product_title, variant_title }
  ['power', 'subscription-power-barrier'].forEach(function (handle) {
    nativeFetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (!p) return;
        (p.variants || []).forEach(function (v) {
          variantInfo[v.id] = { product_title: p.title, variant_title: v.title };
        });
      })
      .catch(function () {});
  });

  // Read the lines an add-to-cart request is about to add.
  function addedLines(init) {
    var body = init && init.body;
    var out = [];
    try {
      if (body instanceof FormData) {
        var id = body.get('id');
        if (id) out.push({ id: Number(id), quantity: Number(body.get('quantity') || 1) });
      } else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body);
        if (j.items) {
          j.items.forEach(function (it) {
            out.push({ id: Number(it.id), quantity: Number(it.quantity || 1), properties: it.properties });
          });
        } else if (j.id) out.push({ id: Number(j.id), quantity: Number(j.quantity || 1) });
      }
    } catch (e) {}
    return out;
  }

  function missingGifts(cart, lines) {
      var sim = { items: (cart.items || []).slice(), discount_codes: cart.discount_codes };
      lines.forEach(function (l) {
        var info = variantInfo[l.id];
        if (!info) return;
        sim.items.push({
          variant_id: l.id,
          quantity: l.quantity,
          product_title: info.product_title,
          variant_title: info.variant_title,
          final_line_price: 1,
          properties: l.properties || {},
        });
      });
      var want = desiredGifts(sim);
      var have = {};
      (cart.items || []).forEach(function (i) {
        if (isAnyGift(i)) have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity;
      });
      var items = [];
      Object.keys(want).forEach(function (id) {
        var missing = want[id].qty - (have[id] || 0);
        if (missing > 0) {
          var props = {};
          props[want[id].prop] = '1';
          items.push({ id: Number(id), quantity: missing, properties: props });
        }
      });
      return items;
  }

  function preAddGifts(lines) {
    var base = lastCart ? Promise.resolve(lastCart) : getCart();
    return base.then(function (cart) {
      var items = missingGifts(cart, lines);
      if (!items.length) return;
      return nativeFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
    });
  }

  // Turn the theme's single-item FormData into one multi-item request:
  // items[0] = what the customer added, items[1..] = the gifts.
  function withGifts(fd, gifts) {
    var out = new FormData();
    fd.forEach(function (value, key) {
      if (key === 'id') out.append('items[0][id]', value);
      else if (key === 'quantity') out.append('items[0][quantity]', value);
      else if (key === 'selling_plan') out.append('items[0][selling_plan]', value);
      else if (key.indexOf('properties[') === 0) out.append('items[0][' + key.replace(/\]$/, '').replace('[', '][') + ']', value);
      else out.append(key, value);
    });
    if (!fd.get('quantity')) out.append('items[0][quantity]', '1');
    gifts.forEach(function (g, n) {
      var i = n + 1;
      out.append('items[' + i + '][id]', String(g.id));
      out.append('items[' + i + '][quantity]', String(g.quantity));
      Object.keys(g.properties).forEach(function (k) {
        out.append('items[' + i + '][properties][' + k + ']', g.properties[k]);
      });
    });
    return out;
  }

  var addQueue = Promise.resolve();

  function isAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  // Watch every cart / discount request made by the theme, apps and the popup.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (isAddUrl(url)) {
      var lines = addedLines(init).filter(function (l) {
        return variantInfo[l.id];
      });
      if (lines.length && init && init.body instanceof FormData) {
        // No extra cart check here (keeps add-to-cart instant). If the snapshot is stale
        // (e.g. a double click) the sync after the add and the checkout guard fix it.
        var run = addQueue.then(function () {
          return (lastCart ? Promise.resolve(lastCart) : getCart()).then(function (cart) {
            lastCart = cart;
            var gifts = missingGifts(cart, lines);
            var init2 = init;
            if (gifts.length) {
              init2 = {};
              Object.keys(init).forEach(function (k) {
                init2[k] = init[k];
              });
              init2.body = withGifts(init.body, gifts);
              gifts.forEach(function (g) {
                if (g.id === CREATINE_30) expect.creatine = true;
                if (g.id === GIFT_KIWI) expect.kiwi = true;
              });
            }
            return nativeFetch(input, init2);
          }, function () {
            return nativeFetch(input, init);
          });
        });
        addQueue = run
          .then(function (res) {
            return res && res.clone().text();
          })
          .catch(function () {});
        run.then(schedule, schedule);
        return run;
      }
      if (lines.length) {
        var go = function () {
          var p2 = nativeFetch(input, init);
          p2.then(schedule, schedule);
          return p2;
        };
        return preAddGifts(lines).then(go, go);
      }
    }
    var p = nativeFetch(input, init);
    if (isCartUrl(url)) p.then(schedule, schedule);
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(url)) this.addEventListener('loadend', schedule);
    return xhrOpen.apply(this, arguments);
  };

  // Gift rows in the drawer: no product link, gift line instead of the plan line;
  // creatine also shows "🎁 ₪0" and has no quantity / remove controls.
  var style = document.createElement('style');
  style.textContent =
    '.bcart-item[data-gift-creatine] .bcart-item__qty,' +
    '.bcart-item[data-gift-creatine] cart-remove-button{visibility:hidden}' +
    '.bcart-gift-price{display:inline-flex;gap:.4rem;align-items:center}' +
    '.bcart .bcart-item[data-gift-creatine] .bcart-item__media img{height:12rem!important;object-fit:contain!important}';
  document.head.appendChild(style);

  function unlink(row) {
    var links = row.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var s = document.createElement('span');
      s.className = a.className;
      s.innerHTML = a.innerHTML;
      a.parentNode.replaceChild(s, a);
    }
  }
  // Rows are matched by variant (not by position), so they are right even
  // when the drawer re-renders before our cart snapshot is refreshed.
  var expect = { creatine: false, kiwi: false }; // gifts sent in the fast path, not yet in lastCart
  function giftKinds() {
    var k = { creatine: expect.creatine, kiwi: expect.kiwi };
    ((lastCart && lastCart.items) || []).forEach(function (i) {
      if (isCreatineGift(i)) k.creatine = true;
      if (i.variant_id === GIFT_KIWI && isSachetGift(i)) k.kiwi = true;
    });
    return k;
  }
  function decorate() {
    var k = giftKinds();
    var rows = document.querySelectorAll('#CartDrawer .bcart-item');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var input = row.querySelector('[data-quantity-variant-id]');
      var vid = input ? Number(input.getAttribute('data-quantity-variant-id')) : 0;
      var creatine = vid === CREATINE_30 && (k.creatine || !lastCart);
      var sachet = vid === GIFT_GRAPE || (vid === GIFT_KIWI && k.kiwi);
      if (!creatine && !sachet) continue;
      var plan = row.querySelector('.bcart-item__plan');
      var label = creatine ? CREATINE_LABEL : GIFT_LABELS[vid];
      if (plan && label && plan.textContent !== label) plan.textContent = label;
      unlink(row);
      if (creatine) {
        if (!row.hasAttribute('data-gift-creatine')) row.setAttribute('data-gift-creatine', '');
        var price = row.querySelector('.bcart-item__price');
        if (price && !price.querySelector('.bcart-gift-price')) {
          price.innerHTML = '<span class="bcart-gift-price"><span aria-hidden="true">🎁</span><span>₪0</span></span>';
        }
      }
    }
  }
  // Runs in the MutationObserver callback (a microtask, before the browser paints),
  // so a freshly rendered drawer never shows the raw ₪159 / product links.
  var decorating = false;
  function startDecorate() {
    new MutationObserver(function () {
      if (decorating) return;
      decorating = true;
      try {
        decorate();
      } finally {
        decorating = false;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Checkout guard: before going to checkout, make sure the gift quantities are right
  // (covers a quantity change in the drawer followed by an immediate checkout click).
  var leaving = false;
  window.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, [name="checkout"]');
      if (!btn || btn.disabled || leaving) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      leaving = true;
      var go = function () {
        var form = btn.form || document.getElementById('CartDrawer-Form');
        if (form) {
          if (!form.querySelector('input[name="checkout"]')) {
            var i = document.createElement('input');
            i.type = 'hidden';
            i.name = 'checkout';
            i.value = '';
            form.appendChild(i);
          }
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      };
      clearTimeout(timer);
      var done = false;
      var once = function () {
        if (done) return;
        done = true;
        go();
      };
      Promise.resolve(sync()).then(once, once);
      setTimeout(once, 4000); // never block checkout for more than 4s
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startDecorate();
      schedule();
    });
  } else {
    startDecorate();
    schedule();
  }
  window.addEventListener('pageshow', function () {
    leaving = false;
    schedule();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') schedule();
  });
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
